import { createIcon } from './createIcon'

export const PalletsIcon = createIcon({
  displayName: 'PalletsIcon',
  viewBox: '0 0 20 20',
  defaultProps: { boxSize: '16px' },
  path: [
    <mask
      id="mask0_1403_2347"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="2"
      width="20"
      height="17"
    >
      <path d="M20 2.375H0V18.625H20V2.375Z" fill="white" />
    </mask>,
    <g mask="url(#mask0_1403_2347)">
      <path
        d="M20 18.25C20 18.4571 19.8321 18.625 19.625 18.625H17.2962C17.0891 18.625 16.9212 18.4571 16.9212 18.25V16.9688C16.9212 16.7616 16.7534 16.5938 16.5463 16.5938H11.7041C11.497 16.5938 11.3291 16.7616 11.3291 16.9688V18.25C11.3291 18.4571 11.1613 18.625 10.9541 18.625H8.54626C8.33916 18.625 8.17126 18.4571 8.17126 18.25V16.9688C8.17126 16.7616 8.00338 16.5938 7.79626 16.5938H3.45374C3.24662 16.5938 3.07874 16.7616 3.07874 16.9688V18.25C3.07874 18.4571 2.91084 18.625 2.70374 18.625H0.375C0.167887 18.625 0 18.4571 0 18.25V16.5938V14.9375C0 14.7304 0.167887 14.5625 0.375 14.5625H19.625C19.8321 14.5625 20 14.7304 20 14.9375V16.5938V18.25Z"
        fill="currentColor"
      />
      <path
        d="M8.97363 2.375C9.24977 2.375 9.47363 2.59886 9.47363 2.875V6.95312C9.47363 7.22926 9.24977 7.45312 8.97363 7.45312H0.5C0.223863 7.45312 6.44281e-08 7.22926 0 6.95312V2.875C6.44286e-08 2.59886 0.223863 2.375 0.5 2.375H8.97363ZM2.61328 3.39062C2.33282 3.39062 2.10547 3.61798 2.10547 3.89844C2.10547 4.17889 2.33282 4.40625 2.61328 4.40625H6.86035C7.14081 4.40625 7.36816 4.17889 7.36816 3.89844C7.36816 3.61798 7.14081 3.39062 6.86035 3.39062H2.61328Z"
        fill="currentColor"
      />
      <path
        d="M19.4998 2.375C19.7759 2.375 19.9998 2.59886 19.9998 2.875V6.95312C19.9998 7.22926 19.7759 7.45312 19.4998 7.45312H11.0261C10.75 7.45303 10.5261 7.2292 10.5261 6.95312V2.875C10.5261 2.59892 10.75 2.3751 11.0261 2.375H19.4998ZM13.1394 3.39062C12.8589 3.39062 12.6316 3.61798 12.6316 3.89844C12.6316 4.17889 12.8589 4.40625 13.1394 4.40625H17.3865C17.6669 4.40625 17.8943 4.17889 17.8943 3.89844C17.8943 3.61798 17.6669 3.39062 17.3865 3.39062H13.1394Z"
        fill="currentColor"
      />
      <path
        d="M19.4998 8.46875C19.7759 8.46875 19.9998 8.69261 19.9998 8.96875V13.0469C19.9998 13.323 19.7759 13.5469 19.4998 13.5469H11.0261C10.75 13.5468 10.5261 13.3229 10.5261 13.0469V8.96875C10.5261 8.69267 10.75 8.46885 11.0261 8.46875H19.4998ZM13.1394 9.48438C12.8589 9.48438 12.6316 9.71173 12.6316 9.99219C12.6316 10.2726 12.8589 10.5 13.1394 10.5H17.3865C17.6669 10.5 17.8943 10.2726 17.8943 9.99219C17.8943 9.71173 17.6669 9.48438 17.3865 9.48438H13.1394Z"
        fill="currentColor"
      />
      <path
        d="M8.97363 8.46875C9.24977 8.46875 9.47363 8.69261 9.47363 8.96875V13.0469C9.47363 13.323 9.24977 13.5469 8.97363 13.5469H0.5C0.223863 13.5469 0 13.323 0 13.0469V8.96875C0 8.69261 0.223863 8.46875 0.5 8.46875H8.97363ZM2.61328 9.48438C2.33282 9.48438 2.10547 9.71173 2.10547 9.99219C2.10547 10.2726 2.33282 10.5 2.61328 10.5H6.86035C7.14081 10.5 7.36816 10.2726 7.36816 9.99219C7.36816 9.71173 7.14081 9.48438 6.86035 9.48438H2.61328Z"
        fill="currentColor"
      />
    </g>,
  ],
})
